import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from 'ducks';

export interface MoveButtonsMenuState {
  show: boolean;
}

const initialState: MoveButtonsMenuState = {
  show: false
};

const moveButtonsMenuStateSlice = createSlice({
  name: 'moveButtonsMenu',
  initialState,
  reducers: {
    showMoveButtonsMenu(state) {
      state.show = true;
    },
    hideMoveButtonsMenu(state) {
      state.show = false;
    },
    setShowMoveButtonsMenu(state, action: PayloadAction<boolean>) {
      state.show = action.payload;
    }
  }
});

export const getShowMoveButtonsMenu = (state: RootState) => state.moveButtonsMenu.show;

export const {
  showMoveButtonsMenu,
  hideMoveButtonsMenu,
  setShowMoveButtonsMenu
} = moveButtonsMenuStateSlice.actions;
export default moveButtonsMenuStateSlice.reducer;
